/**
 * Публичный клиент темы (E15 / ФТ-8.3).
 */

import type { ThemeSettings } from "@potok/shared";
import { apiRequest } from "./http";

export async function loadPublicTheme(): Promise<ThemeSettings> {
  return apiRequest<ThemeSettings>("/theme");
}
